<app-drake-field 
    [fieldConfig]="f" 
    *ngFor="let f of viewConfig.viewFields" 
    (valueChanged)="valueChanged($event)"
    [baseData]="baseData[scope][id]"
    [readonly]="readonly"
    [mode]="'DEFAULT'">
</app-drake-field>
